<!--
  REV-22527 — the import of a started closing, as a note over the overview (Pure View).

  The look is the house note (`dh-sync-note` in Dokumente): grey box, one line. Selector contract:
  tests bind to `data-testid` and `data-*` markers. See e2e-lab/closing-import-banner.lab.spec.ts.

  No close control: the import runs on the server and has no cancel route.
-->
<div class="import" [attr.data-state]="state" data-testid="closing-import-banner" role="status">
    <div class="import__line">
        <span class="import__icon" aria-hidden="true">
            <span class="import__spinner" *ngIf="state === 'running'">
                <lucide-icon name="loader-circle" [size]="16"></lucide-icon>
            </span>
            <lucide-icon *ngIf="state === 'done'" name="check" [size]="16"></lucide-icon>
            <lucide-icon *ngIf="state === 'failed'" name="alert-circle" [size]="16"></lucide-icon>
        </span>
        <span class="import__title" data-testid="closing-import-title">{{
            (state === 'done'
                ? 'abcp.setup.import.doneTitle'
                : state === 'failed'
                ? 'abcp.setup.import.failedTitle'
                : 'abcp.setup.import.title'
            ) | i18next
        }}</span>

        <span
            class="import__row"
            *ngFor="let row of rows; trackBy: trackByKey"
            data-testid="closing-import-row"
            [attr.data-row]="row.key"
            [attr.data-status]="row.status"
        >
            <span class="import__sep" aria-hidden="true">·</span>
            <span class="import__label">{{ row.label }}</span>
            <lucide-icon *ngIf="row.status === 'done'" class="import__done" name="check" [size]="14"></lucide-icon>
            <span class="import__detail" data-testid="closing-import-detail" *ngIf="row.detail"
                >({{ row.detail }})</span
            >
        </span>
    </div>

    <div class="import__error" data-testid="closing-import-error" *ngIf="state === 'failed'">
        <span class="import__error-message" data-testid="closing-import-error-message">{{ failureMessage }}</span>
        <ham-button data-testid="closing-import-retry" variant="white" size="sm" (buttonClick)="onRetry()">
            {{ 'abcp.setup.import.retry' | i18next }}
        </ham-button>
        <span class="import__retry-error" data-testid="closing-import-retry-error" *ngIf="retryError" role="alert">{{
            retryError
        }}</span>
    </div>
</div>
